import { useShallowEqualSelector } from "@/app/_helpers/redux";

import { useAppPermissions } from "../../hooks/use-app-permissions";

import { MyDashboardMenuItem } from "./components/1-my-dashboard-menu-item";
import { MyConsultsMenuItem } from "./components/3-my-consults-menu-item";
import { MyClientsMenuItem } from "./components/4-my-clients-menu-item";
import {
  TeamMenuItem,
  TimeOffMenuItem,
} from "./components/6-team-and-time-off-menu-items";
import { PanelManagementMenuItem } from "./components/8-panel-management-menu-item";
import { GroupTherapyMenuItem } from "./components/9-group-therapy-menu-item";
import { MyAvailabilityMenuItem } from "./components/10-cogsworth-tool-menu-item";
import { MyProfileMenuItem } from "./components/11-my-profile-menu-item";

interface TopMainNavigationMenuItemsProps {
  isCollapsed: boolean;
}

export function TopMainNavigationMenuItems({
  isCollapsed,
}: TopMainNavigationMenuItemsProps) {
  const {
    hasMyClientsPermissions,
    hasTeamPermissions,
    hasTimeOffPermissions,
    hasGroupTherapyPermissions,
    hasViewClinicianMetricsEnabled,
  } = useAppPermissions();

  const [currentUser] = useShallowEqualSelector((state) => [
    state.auth.currentUser,
  ]);

  return (
    <>
      {currentUser ? <MyDashboardMenuItem isCollapsed={isCollapsed} /> : null}

      <MyConsultsMenuItem isCollapsed={isCollapsed} />

      {hasMyClientsPermissions ? (
        <MyClientsMenuItem isCollapsed={isCollapsed} />
      ) : null}

      {hasViewClinicianMetricsEnabled ? (
        <MyProfileMenuItem isCollapsed={isCollapsed} />
      ) : null}

      {hasGroupTherapyPermissions ? (
        <GroupTherapyMenuItem isCollapsed={isCollapsed} />
      ) : null}

      {hasTeamPermissions ? <TeamMenuItem isCollapsed={isCollapsed} /> : null}

      {hasTimeOffPermissions ? (
        <TimeOffMenuItem isCollapsed={isCollapsed} />
      ) : null}

      <MyAvailabilityMenuItem isCollapsed={isCollapsed} />

      {currentUser && !hasViewClinicianMetricsEnabled ? (
        <PanelManagementMenuItem isCollapsed={isCollapsed} />
      ) : null}
    </>
  );
}
